import { render } from "./HowWeWork.vue?vue&type=template&id=5d73d0c0"
import script from "./HowWeWork.vue?vue&type=script&lang=js"
export * from "./HowWeWork.vue?vue&type=script&lang=js"

import "./HowWeWork.vue?vue&type=style&index=0&id=5d73d0c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__